module.exports = __webpack_public_path__ + "img/bg.75404004.png";